var ProductNotifyModal = {
  formFields: [
    {name: "email", required: true}
  ],
};
ProductNotifyModal.open = function (product) {
  ProductNotifyModal.product = product;
  $('#notifyMe').popup('show');
  $('#notifyMe form button').off('click', ProductNotifyModal.subscribe).on('click', ProductNotifyModal.subscribe);
};
ProductNotifyModal.subscribe = function () {
  var form = document.forms.productNotifyForm;
  $(form).find('.form-error').hide();
  var errors = Forms.validateFields(form, ProductNotifyModal.formFields);
  if (errors.length === 0) {
    jQuery.ajax({
      url: "/shop/product/" + ProductNotifyModal.product._id + "/subscribe-availability",
      method: "post",
      data: JSON.stringify({
        version: ProductNotifyModal.product.version,
        email: form.elements.email.value
      }),
      contentType: 'application/json; charset=utf-8',
      success: function () {
        $('#notifyMeSuccess').popup('show');
      }
    });
    $('#notifyMe').popup('hide');
  }
};